import gql from 'graphql-tag';

export default gql`
  mutation addUserGroupRole($userGroupRole: UserGroupRoleInput!) {
    addUserGroupRole(userGroupRole: $userGroupRole)
  }
`;
